export default function StatCard({ label, value, hint, accent, icon: Icon }) {
  return (
    <div
      className={`relative overflow-hidden p-4 rounded-2xl border transition-shadow hover:shadow-md ${
        accent
          ? 'border-theme-primary/30 bg-gradient-to-br from-theme-primary/10 to-transparent'
          : 'border-theme-secondary bg-theme-main'
      }`}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <div className="text-xs uppercase tracking-wide opacity-50 mb-1">{label}</div>
          <div className={`text-2xl font-semibold truncate tabular-nums ${accent ? 'text-theme-primary' : ''}`}>
            {value}
          </div>
          {hint && <div className="text-xs opacity-45 mt-1">{hint}</div>}
        </div>
        {Icon && (
          <div className="shrink-0 w-8 h-8 rounded-xl bg-theme-secondary/60 flex items-center justify-center opacity-70">
            <Icon className="w-4 h-4" />
          </div>
        )}
      </div>
    </div>
  );
}
